export const cn = (...clazz: (string | undefined | null)[]) => clazz.join(' ').trim();

const sharpenURI = document.location.host.split('.').splice(1, 2).join('.');
export const isSharpenOrLocal = ['sharpennotes.com', 'localhost:8080'].includes(sharpenURI);

export const requestOptions = (token?: string, method = 'GET') => ({
  method,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const replaceAsync = async (input: string, regex: RegExp, replacer: (p: any) => Promise<string>) => {
  // we need to remove the 'g' flag, if defined, so that all replacements can be made
  const flags = (regex.flags || '').replace('g', '');
  const re = new RegExp(regex.source || regex, flags);
  let index = 0;
  let match: RegExpExecArray | null;

  while ((match = re.exec(input.slice(index)))) {
    // eslint-disable-next-line prefer-spread
    const value = await replacer.apply(null, match as any);
    index += match.index;
    input = input.slice(0, index) + value + input.slice(index + match[0].length);
    index += match[0].length;

    // if 'g' was not defined on flags, break
    if (flags === regex.flags) {
      break;
    }
  }

  return input;
};
